import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_HOME_WIDGET_MENU_ITEMS_API_ID =
  'DASHBOARD/FETCH_HOME_WIDGET_MENU_ITEMS_API_ID';

const apiCall = createApiCall(
  FETCH_HOME_WIDGET_MENU_ITEMS_API_ID,
  (params: { home_widget_id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/home-widget-menu-items`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
